import { ApiPaths } from "../../../api/ApiPaths";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { Height } from "../../../../domain/assessment/Height";
import { Weight } from "../../../../domain/assessment/Weight";
import { Disease } from "../../../../domain/assessment/Disease";
import { OtherDiseases } from "../../../../domain/assessment/OtherDiseases";
import { LifeStatus } from "../../../../domain/assessment/LifeStatus";
import { FamilyDistance } from "../../../../domain/assessment/FamilyDistance";
import { NursingDegree } from "../../../../domain/assessment/NursingDegree";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetAssessmentInfoSuccessResponseType = {
    careRecipientDetail: {
        height: number | null,
        weight: number | null,
        weekdayLifeStatus: string,
        holidayLifeStatus: string,
        familyDistance: string,
        nursingDegree: string,
        bathAtHome: boolean
    },
    sufferedDisease: [{
        disease: string
    }],
    otherSufferedDiseases: {
        diseases: string
    },
    dosingMedicine: {
        diuretic: boolean
    }
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getAssessmentInfo(
    careRecipientId: CareRecipientId
): Promise<GetAssessmentInfoSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.assessment.info,
        {
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {}
    );
}

export async function updateAssessmentInfo(
    careRecipientId: CareRecipientId,
    height: Height,
    weight: Weight,
    weekdayLifeStatus: LifeStatus | undefined,
    holidayLifeStatus: LifeStatus | undefined,
    familyDistance: FamilyDistance | undefined,
    nursingDegree: NursingDegree | undefined,
    sufferedDisease: (Disease | undefined)[],
    otherSufferedDiseases: OtherDiseases,
    diuretic: boolean,
    bathAtHome: boolean,
) {
    const body = {
        careRecipientDetail: {
            height: height.value === "" ? null : Number(height.value),
            weight: weight.value === "" ? null : Number(weight.value),
            nursingDegree: nursingDegree?.value,
            weekdayLifeStatus: weekdayLifeStatus?.value,
            holidayLifeStatus: holidayLifeStatus?.value,
            familyDistance: familyDistance?.value,
            bathAtHome: bathAtHome
        },
        sufferedDisease: sufferedDisease.map(it => (
            { disease: it?.value }
        )),
        otherSufferedDiseases: {
            diseases: otherSufferedDiseases.value
        },
        dosingMedicine: {
            diuretic: diuretic
        }
    };
    return await ApiRequest.post(
        ApiPaths.assessment.info,
        {
            care_recipient_id: careRecipientId.value
        },
        body,
        () => {},
        () => {}
    );
}
